/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Uploader_ReplaceInputs */

const en_common_uploader_replace = /** @type {(inputs: Common_Uploader_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace image`)
};

const zh_common_uploader_replace = /** @type {(inputs: Common_Uploader_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更换图片`)
};

/**
* | output |
* | --- |
* | "Replace image" |
*
* @param {Common_Uploader_ReplaceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_uploader_replace = /** @type {((inputs?: Common_Uploader_ReplaceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Uploader_ReplaceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_uploader_replace(inputs)
	return zh_common_uploader_replace(inputs)
});
export { common_uploader_replace as "common.uploader.replace" }